import type { Spritesheet, Texture } from 'pixi.js';

/**
 * Icon atlases, in lookup order. The DOM `Icon` component merges *every*
 * spritesheet into `FRAME_LOOKUP`, so a frame outside the base `icons` sheet
 * (e.g. `run-modifier` in `icons-more`) resolves in the inventory. The PIXI
 * renderers (ground items, pickup notifications, buff badges) must scan the
 * same icon atlases, otherwise such sprites fall back to the purple placeholder
 * on the ground while looking fine in the inventory.
 */
const ICON_ATLASES = ['icons', 'icons-more', 'rune-icons'] as const;

/** Resolves a frame's `Texture` across the icon atlases from the sprites store. */
export function resolveIconTexture(
  textures: Record<string, Spritesheet>,
  frameName: string | undefined,
): Texture | undefined {
  if (!frameName) {
    return undefined;
  }
  for (const atlas of ICON_ATLASES) {
    const tex = textures[atlas]?.textures?.[frameName];
    if (tex) {
      return tex;
    }
  }
  return undefined;
}
